// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-action-container {
  display: flex;
}
.input-action-container .input-wrapper {
  background: var(--base_color2);
  padding: 0;
  flex: 1 1;
  display: flex;
  border-radius: 4px;
}
.input-action-container .input-wrapper:focus-within input,
.input-action-container .input-wrapper:focus-within .icon-wrapper,
.input-action-container .input-wrapper:focus-within .language-selector {
  border-color: var(--color_primary_500);
}
.input-action-container .input-wrapper input {
  border: 1px solid var(--gray_light1);
  border-left: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 8px;
  display: block;
  width: 100%;
  box-sizing: border-box;
  color: var(--gray_dark2);
  margin: 0;
}
.input-action-container .input-wrapper input:disabled {
  background: var(--color_neutral_100);
}
.input-action-container .input-wrapper .language-selector {
  display: flex;
  border: 1px solid var(--gray_light1);
  border-right: none;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.input-action-container .input-wrapper .language-selector .select-icon-group {
  border: none;
}
.input-action-container .input-wrapper .language-selector .icon-wrapper {
  border: none;
}
.input-action-container .input-wrapper .language-selector .filter {
  min-width: 140px;
  max-width: 160px;
}
.input-action-container .input-wrapper .language-selector .filter > div {
  transition: all 0s;
  border: none;
  border-radius: 0;
  min-height: 42px;
}
.input-action-container .input-wrapper .language-selector .filter > div > div:nth-child(2) {
  flex-direction: row-reverse;
}
.input-action-container .icon-wrapper {
  height: 38px;
  align-self: center;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid var(--gray_light1);
  border-right: 0;
  padding-left: 8px;
  display: flex;
}
.input-action-container .icon-wrapper .InputAction-icon {
  height: 40%;
  align-self: center;
  justify-self: center;
}
.input-action-container .icon-wrapper .InputAction-icon rect {
  fill: none;
}
.input-action-container.disabled .icon-wrapper {
  background: var(--color_neutral_100);
}`, "",{"version":3,"sources":["webpack://./src/components/InputAction/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,8BAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;AACJ;AAGM;;;EAGE,sCAAA;AADR;AAKI;EACE,oCAAA;EACA,cAAA;EACA,4BAAA;EACA,+BAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,sBAAA;EACA,wBAAA;EACA,SAAA;AAHN;AAIM;EACE,oCAAA;AAFR;AAMI;EACE,aAAA;EACA,oCAAA;EACA,kBAAA;EACA,2BAAA;EACA,8BAAA;AAJN;AAMM;EACE,YAAA;AAJR;AAOM;EACE,YAAA;AALR;AAQM;EACE,gBAAA;EACA,gBAAA;AANR;AAQQ;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AANV;AAQU;EACE,2BAAA;AANZ;AAaE;EACE,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,8BAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AAXJ;AAaI;EACE,WAAA;EACA,kBAAA;EACA,oBAAA;AAXN;AAYM;EACE,UAAA;AAVR;AAgBI;EACE,oCAAA;AAdN","sourcesContent":[".input-action-container {\n  display: flex;\n\n  .input-wrapper {\n    background: var(--base_color2);\n    padding: 0;\n    flex: 1;\n    display: flex;\n    border-radius: 4px;\n\n    &:focus-within {\n\n      input,\n      .icon-wrapper,\n      .language-selector {\n        border-color: var(--color_primary_500);\n      }\n    }\n\n    input {\n      border: 1px solid var(--gray_light1);\n      border-left: 0;\n      border-top-right-radius: 4px;\n      border-bottom-right-radius: 4px;\n      padding: 8px;\n      display: block;\n      width: 100%;\n      box-sizing: border-box;\n      color: var(--gray_dark2);\n      margin: 0;\n      &:disabled {\n        background: var(--color_neutral_100);\n      }\n    }\n\n    .language-selector {\n      display: flex;\n      border: 1px solid var(--gray_light1);\n      border-right: none;\n      border-top-left-radius: 4px;\n      border-bottom-left-radius: 4px;\n\n      .select-icon-group {\n        border: none;\n      }\n\n      .icon-wrapper {\n        border: none;\n      }\n\n      .filter {\n        min-width: 140px;\n        max-width: 160px;\n\n        &>div {\n          transition: all 0s;\n          border: none;\n          border-radius: 0;\n          min-height: 42px;\n\n          &>div:nth-child(2) {\n            flex-direction: row-reverse;\n          }\n        }\n      }\n    }\n  }\n\n  .icon-wrapper {\n    height: 38px;\n    align-self: center;\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    border: 1px solid var(--gray_light1);\n    border-right: 0;\n    padding-left: 8px;\n    display: flex;\n\n    .InputAction-icon {\n      height: 40%;\n      align-self: center;\n      justify-self: center;\n      rect {\n        fill: none;\n      }\n    }\n  }\n\n  &.disabled {\n    .icon-wrapper {\n      background: var(--color_neutral_100);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
